<script setup lang="ts">
  import { i18n } from '@/plugins';

  import Container from './Container.vue';
  import FeatureCard from './FeatureCard.vue';

  const features = [
    {
      id: 1,
      image: '/static/img/compare-ll-plans-inventory-insights-card-bg.png',
      keypath: 'inventoryInsights.upgradeLeafLinkPlusPage.features.cards.inventoryInsights',
      keywords: ['inventoryInsights.upgradeLeafLinkPlusPage.plans.list.inventoryInsights.title'],
    },
    {
      id: 2,
      image: '/static/img/compare-ll-plans-account-integrations-card-bg.png',
      keypath: 'inventoryInsights.upgradeLeafLinkPlusPage.features.cards.accountingIntegrations',
      keywords: ['inventoryInsights.upgradeLeafLinkPlusPage.plans.list.accountingIntegrations.title'],
    },
  ];
</script>

<template>
  <section class="tw-bg-ice-100 tw-py-16">
    <Container class="tw-grid tw-place-content-center max-lg:tw-px-6 max-md:tw-px-4">
      <h2 class="tw-text-center tw-text-4xl">
        {{ i18n.t('inventoryInsights.upgradeLeafLinkPlusPage.features.title') }}
      </h2>

      <div class="tw-grid tw-place-content-center tw-gap-12 tw-pt-12 lg:tw-grid-cols-2">
        <FeatureCard v-for="{ id, image, keypath, keywords } in features" :key="id" :image :keypath :keywords />
      </div>
    </Container>
  </section>
</template>
